angular.module('app.api').factory('RecommendationsApi', [
  'api',
  function RecommendationsApi(api) {
    const recommendationsApi = {
      unHideCandidateEmployer: (id, payload) => {
        return api.put(`users/${id}/hidden`, payload)
      },
      unHideCandidatePosition: (id, payload) => {
        return api.put(`users/${id}/positions/hidden`, payload)
      },
      getCandidateRecommendations: async (id, options = {}) => {
        const result = await api.get(`recommendations/candidate/${id}/admin`, {
          params: options,
        })

        return result
      },
    }
    return recommendationsApi
  },
])



// WEBPACK FOOTER //
// ./scripts/candidate-profile/recommendations/recommendations.api.js